<app-loader-circles *ngIf="showLoader"></app-loader-circles>
<section id="main-container">
  <div id="main" class="col-xs-12">
    <app-breadcrumb currentPage="Minhas Fichas" routerCurrentPage="/ficha" voltar="hide"></app-breadcrumb>

    <!-- FICHAS -->
    <div id="records" class="row">
      <div class="col-xs-12">
        <div class="row">
          <div class="col-xs-12">
            <h2 class="record-title">Minhas Fichas</h2>
          </div>
        </div>

        <div class="produto-resultado">
          <app-select-produto (filtrarPorProduto)="onChangeFiltroProdutos($event)"
                              [disabled]="isPesquisandoEmAnalise || isPesquisandoAprovada || isPesquisandoEmFechamento || isPesquisandoisRecusada || isPesquisandoisContratoCancelado"
                              [isPanel]="false" #produtos></app-select-produto>
          <div class="resultado-content">Resultados:
            <button class="btn btn-card-list" [ngClass]="{'active': isCardView}" (click)="onChangeView(true)">Card
            </button>
            <button class="btn btn-card-list" [ngClass]="{'active': !isCardView}" (click)="onChangeView(false)">Lista
            </button>
          </div>
        </div>

        <!-- Nav tabs -->
        <ul class="nav nav-tabs" role="tablist">
          <li role="presentation" [ngClass]="{'active' : isEmAnalise}">
            <a href="#analise" (click)="onClickEmAnalise()" aria-controls="" role="tab" data-toggle="tab">
              Fichas em Análise
              <span *ngIf="isPesquisandoEmAnalise">
                <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
              </span>
              <app-notificacao-aba [quantidade]="quantSosPropostasEmAnalise"></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{'active' : isAprovada}">
            <a href="#aprovadas" (click)="onClickEmAprovada()" aria-controls="" role="tab" data-toggle="tab">
              Fichas Aprovadas
              <span *ngIf="isPesquisandoAprovada">
                <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
              </span>
              <app-notificacao-aba [quantidade]="quantSosPropostasAprovadas"></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{'active' : isEmFechamento}">
            <a href="#fechamento" (click)="onClickEmFechamento()" aria-controls="" role="tab" data-toggle="tab">
              Pagamentos
              <span *ngIf="isPesquisandoEmFechamento">
                <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
              </span>
              <app-notificacao-aba [quantidade]="quantSosPropostasEmFechamento"></app-notificacao-aba>
            </a>
          </li>

          <li role="presentation" [ngClass]="{'active' : isRecusada}">
            <a href="#recusadas" (click)="onClickEmRecusada()" aria-controls="" role="tab" data-toggle="tab">
              Recusadas
              <span *ngIf="isPesquisandoEmFechamento">
                <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
              </span>
            </a>
          </li>

          <li role="presentation" [ngClass]="{'active' : isContratoCancelado}" *ngIf="showContratoCancelado">
            <a href="#canceladas" (click)="onClickEmContratoCancelado()" aria-controls="" role="tab" data-toggle="tab">
              Contrato Cancelado
              <span *ngIf="isPesquisandoEmFechamento">
                <em class="fa fa-spinner fa-pulse" aria-hidden="true"></em>
              </span>
            </a>
          </li>

          <li class="pull-right">
            <a (click)="isFilters = !isFilters" class="filters" title="Filtrar fichas de análise">
              <em class="fa fa-search"></em> Filtrar Fichas
            </a>
          </li>
          <li class="pull-right">
            <a (click)="refreshFichas()" class="filters">
              <em class="fa fa-refresh"></em> Recarregar</a>
          </li>
        </ul>
        <div *ngIf="isFilters" class="row filter-panel">

          <div class="col-lg-2 col-md-6">
            <label for="status">Nome ou CPF do cliente</label>
            <input type="text" class="form-control" name="nome" (change)="filtro" [(ngModel)]="filtro.nomeCpf">
          </div>

          <div class="col-lg-2 col-md-3">
            <label for="operator">Número da ficha</label>
            <input type="text" class="form-control" name="numero" [(ngModel)]="filtro.numero">
          </div>

          <div class="col-lg-2 col-md-3">
            <label for="operator">Status da Ficha</label>
            <select class="form-control" id="status" name="status" [(ngModel)]="filtro.status">
              <option *ngFor="let item of status" value="{{ item.valor }}">{{ item.descricao }}</option>
            </select>
          </div>

          <div class="col-lg-2 col-md-3">
            <label for="datas">Dias</label>
            <select class="form-control" name="data" [(ngModel)]="filtro.data">
              <option value=""></option>
              <option value="5">Últimos 5 dias</option>
              <option value="10">Últimos 10 dias</option>
              <option value="15">Últimos 15 dias</option>
              <option value="20">Últimos 20 dias</option>
              <option value="25">Últimos 25 dias</option>
              <option value="30">Últimos 30 dias</option>
            </select>
          </div>
          <div class="col-lg-1 col-md-3 text-center">
            <label for="datas">Com SOS</label>
            <br>
            <input type="checkbox" name="sos" [(ngModel)]="filtro.sos">
          </div>
        </div>
        <!-- Tab panes -->
        <div class="tab-content" *ngIf="isCardView">
          <!-- FICHAS EM ANÁLISE -->
          <div role="tabpanel" class="tab-pane fade" [ngClass]="{'in active': isEmAnalise}" id="analise">
            <app-ficha-em-analise (quantidadeSos)="quantidadeSosAnalise($event)" [propostas]="propostasEmAnalise"
                                  [filtro]="filtro"></app-ficha-em-analise>
          </div>
          <!-- FICHAS APROVADAS -->
          <div role="tabpanel" class="tab-pane fade" [ngClass]="{'in active': isAprovada}" id="aprovadas">
            <app-ficha-aprovada (quantidadeSos)="quantidadeSosAprovada($event)" [propostas]="propostasAprovada"
                                [filtro]="filtro"></app-ficha-aprovada>
          </div>
          <!-- FICHAS EM FECHAMENTO -->
          <div role="tabpanel" class="tab-pane fade" [ngClass]="{'in active': isEmFechamento}" id="fechamento">
            <app-ficha-em-fechamento (quantidadeSos)="quantidadeSosFechamento($event)"
                                     [propostas]="propostasEmFechamento"
                                     [filtro]="filtro"></app-ficha-em-fechamento>
          </div>
          <!-- FICHAS RECUSADAS -->
          <div role="tabpanel" class="tab-pane fade" [ngClass]="{'in active': isRecusada}" id="recusadas">
            <app-ficha-recusada [propostas]="propostasRecusada" [filtro]="filtro"
                                *ngIf="isRecusada"></app-ficha-recusada>
          </div>
          <!-- FICHAS CONTRATO CANCELADO -->
          <div role="tabpanel" class="tab-pane fade" [ngClass]="{'in active': isContratoCancelado}" id="canceladas"
               *ngIf="showContratoCancelado">
            <app-ficha-contrato-cancelado [propostas]="propostasContratoCancelado" [filtro]="filtro"
                                          *ngIf="isContratoCancelado"></app-ficha-contrato-cancelado>
          </div>
        </div>
        <div class="tab-content" *ngIf="!isCardView">
          <!-- FICHAS EM ANÁLISE -->
          <div *ngIf="propostasEmAnalise.length > 0" role="tabpanel" class="tab-pane fade"
               [ngClass]="{'in active': isEmAnalise}"
               id="analise">
            <app-lista-ficha-em-analise [propostas]="propostasEmAnalise" [filtro]="filtro"
                                        *ngIf="isEmAnalise"></app-lista-ficha-em-analise>
          </div>

          <div *ngIf="propostasEmAnalise.length === 0 && isEmAnalise">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS APROVADAS -->
          <div *ngIf="propostasAprovada.length > 0" role="tabpanel" class="tab-pane fade"
               [ngClass]="{'in active': isAprovada}"
               id="aprovadas">
            <app-lista-ficha-aprovada [propostas]="propostasAprovada" [filtro]="filtro"
                                      *ngIf="isAprovada"></app-lista-ficha-aprovada>
          </div>

          <div *ngIf="propostasAprovada.length === 0 && isAprovada">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS EM FECHAMENTO -->
          <div *ngIf="propostasEmFechamento.length > 0" role="tabpanel" class="tab-pane fade"
               [ngClass]="{'in active': isEmFechamento}"
               id="fechamento">
            <app-lista-ficha-aprovada [propostas]="propostasEmFechamento" [filtro]="filtro"
                                      *ngIf="isEmFechamento"></app-lista-ficha-aprovada>
          </div>

          <div *ngIf="propostasEmFechamento.length === 0 && isEmFechamento">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS RECUSADAS -->
          <div *ngIf="propostasRecusada.length > 0" role="tabpanel" class="tab-pane fade"
               [ngClass]="{'in active': isRecusada}"
               id="recusadas">
            <app-lista-ficha-recusada [propostas]="propostasRecusada" [filtro]="filtro"
                                      *ngIf="isRecusada"></app-lista-ficha-recusada>
          </div>

          <div *ngIf="propostasRecusada.length === 0 && isRecusada">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

          <!-- FICHAS CONTRATO CANCELADO -->
          <div *ngIf="propostasContratoCancelado.length > 0 && showContratoCancelado" role="tabpanel"
               class="tab-pane fade" [ngClass]="{'in active': isContratoCancelado}"
               id="canceladas">
            <app-lista-ficha-contrato-cancelado [propostas]="propostasContratoCancelado" [filtro]="filtro"
                                                *ngIf="isContratoCancelado"></app-lista-ficha-contrato-cancelado>
          </div>

          <div *ngIf="propostasContratoCancelado.length === 0 && isContratoCancelado">
            <h2>Não foram encontradas propostas para essa fase</h2>
          </div>

        </div>
      </div>
    </div>
  </div>
</section>

<a class="nova-ficha" (click)="addFicha()" title="Adicionar nova ficha">
  <em class="fa fa-plus"></em>
  <span>
    Nova Ficha
  </span>
</a>

<app-modal-message #modalMessage [title]="'Atenção!'" [hideClose]="true"></app-modal-message>

<script src="../../../assets/js/bootstrap-slider.min.js"></script>
